import requests from "./api/base-api";

const LoginService = {
  sendOtp: (body) => requests.post(`/user/v1/send-otp`, body),
  submitOtp: (body) => requests.post(`/user/v1/submit-otp`, body),
  submitInfo: (body) => requests.post(`/user/v1/create-email-user`, body),
  referralCode: (body) => requests.patch(`/user/v1/check-referral-code`, body),

  emailSendOtp: (body) => requests.post(`/user/v1/send-email-otp`, body),
  submitOtpEmail: (body) => requests.post(`/user/v1/submit-otp-email`, body),
  googleCode: (params) => requests.post(`/user/v1/google?platform=web`),
};

export default LoginService;